export interface Post<T> {
  data: T;
}

export interface SingleResponse<T> {
  data: T;
}
export function toPost<T>(objeto: T): Post<T> {
  return {
    data: objeto
  }
}

export interface listarPaginacao {
  page?: number;
  pageSize?: number;
}
